export var EContainerTableFollowupWorkflowsInclude = /*#__PURE__*/function (EContainerTableFollowupWorkflowsInclude) {
  EContainerTableFollowupWorkflowsInclude["Name"] = "name";
  EContainerTableFollowupWorkflowsInclude["Description"] = "description";
  EContainerTableFollowupWorkflowsInclude["UpdatedBy"] = "updatedBy";
  EContainerTableFollowupWorkflowsInclude["Queued"] = "queued";
  EContainerTableFollowupWorkflowsInclude["Enrolled"] = "enrolled";
  EContainerTableFollowupWorkflowsInclude["Completed"] = "completed";
  EContainerTableFollowupWorkflowsInclude["Manual"] = "manual";
  EContainerTableFollowupWorkflowsInclude["Enabled"] = "enabled";
  EContainerTableFollowupWorkflowsInclude["ActionCreate"] = "actionCreate";
  EContainerTableFollowupWorkflowsInclude["ActionAddPatient"] = "actionAddPatient";
  EContainerTableFollowupWorkflowsInclude["ActionViewInstances"] = "actionViewInstances";
  EContainerTableFollowupWorkflowsInclude["ActionEdit"] = "actionEdit";
  EContainerTableFollowupWorkflowsInclude["ActionEnable"] = "actionEnable";
  EContainerTableFollowupWorkflowsInclude["ActionDelete"] = "actionDelete";
  return EContainerTableFollowupWorkflowsInclude;
}({});